import { useQuery, useMutation } from 'react-query'
import { rqDefaultOptions } from './defaultOptions'
import { API_URL } from '../../config'
import axios from 'axios'

const getAgentActions = async (inputObj) => {
  const sourceSummaryAPIPath = `${API_URL}/api/kai/v1/actions`
  const res = await axios.get(sourceSummaryAPIPath)
  return res.data
}

export const patchAgentAction = async (req) => {
  const sourceSummaryAPIPath = `${API_URL}/api/kai/v1/actions`
  return await axios.patch(sourceSummaryAPIPath, req)
}

export const deleteAgentAction = async (req) => {
  const sourceSummaryAPIPath = `${API_URL}/api/kai/v1/actions/${req.actionId}`
  return await axios.delete(sourceSummaryAPIPath)
}

export const getAgentSettings = async (req) => {
  const sourceSummaryAPIPath = `${API_URL}/api/kai/v1/settings`
  const res = await axios.get(sourceSummaryAPIPath, req)
  return res.data
}

export const patchAgentSettings = async (req) => {
  const sourceSummaryAPIPath = `${API_URL}/api/kai/v1/settings`
  return await axios.patch(sourceSummaryAPIPath, req)
}

export function useGetAgentActions(queryKey, setFn) {
  const options = {
    onSuccess: (data) => {
      setFn(data)
    },
    ...rqDefaultOptions,
    refetchOnWindowFocus: false,
    enabled: true,
  }
  return useQuery([queryKey], getAgentActions, options)
}

export function useGetAgentSettings(queryKey, setFn) {
  const options = {
    onSuccess: (data) => {
      setFn(data)
    },
    ...rqDefaultOptions,
    refetchOnWindowFocus: false,
    enabled: true,
  }
  return useQuery([queryKey], getAgentSettings, options)
}

export function usePatchAgentAction() {
  return useMutation(patchAgentAction)
}

export function useDeleteAgentAction() {
  return useMutation(deleteAgentAction)
}

export function usePatchAgentSettings() {
  return useMutation(patchAgentSettings)
}
